
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Neutral name to avoid ad-blockers
const RouteObserver = () => {
    const location = useLocation();

    // Obfuscate variable name slightly
    const measurementId = import.meta.env.VITE_GA_ID;

    useEffect(() => {
        if (!measurementId) return;

        const w = window;
        w.dataLayer = w.dataLayer || [];
        function gtag() { w.dataLayer.push(arguments); }

        if (w.gtag) {
            w.gtag('config', measurementId, { page_path: location.pathname + location.search });
            return;
        }

        // Defer GA loading until after page is interactive (improves LCP/TTI)
        const loadGA = () => {
            gtag('js', new Date());
            gtag('config', measurementId);
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
            document.head.appendChild(script);
            w.gtag = gtag;
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(loadGA, { timeout: 3000 });
        } else {
            setTimeout(loadGA, 1500);
        }
    }, [measurementId, location]);

    return null;
};

export default RouteObserver;
